module.exports = __webpack_public_path__ + "static/media/denis.ac36fab0.jpg";